import { SectionTitle, RunButton, Badge } from '../UI';

const fmtDate = (value) => value ? new Date(value).toLocaleString() : '—';

export default function JobsTab({ jobs, onRefreshJobs }) {
  return (
    <div>
      <div style={{ marginBottom: '24px', display: 'flex', justifyContent: 'space-between', gap: '16px', alignItems: 'center', flexWrap: 'wrap' }}>
        <div>
          <h1 style={{ fontFamily: 'var(--font-display)', fontSize: '24px', fontWeight: '700', marginBottom: '6px' }}>Jobs</h1>
          <p style={{ fontSize: '14px', color: 'var(--text-3)' }}>
            Background execution queue for audits, report generation, PDFs, and batch runs.
          </p>
        </div>
        <RunButton onClick={onRefreshJobs}>Refresh Jobs</RunButton>
      </div>

      <SectionTitle>Recent jobs</SectionTitle>
      <div style={{ display: 'grid', gap: '12px' }}>
        {jobs.length === 0 && <div style={{ color: 'var(--text-3)' }}>No jobs yet.</div>}
        {jobs.map((job) => (
          <div key={job.id} style={{ background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: '12px', padding: '16px 18px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', gap: '16px', flexWrap: 'wrap', marginBottom: '8px' }}>
              <div>
                <div style={{ fontFamily: 'var(--font-mono)', color: 'var(--accent)', fontSize: '13px', marginBottom: '6px' }}>
                  {job.command} {job.url}
                </div>
                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                  <Badge type={job.status === 'completed' ? 'fast' : job.status === 'failed' ? 'generate' : 'deep'}>{job.status}</Badge>
                  {job.batch_id && <Badge type="crm">batch</Badge>}
                </div>
              </div>
              <div style={{ textAlign: 'right', fontSize: '12px', color: 'var(--text-3)', fontFamily: 'var(--font-mono)' }}>
                <div>{fmtDate(job.created_at)}</div>
                <div>{job.progress}%</div>
              </div>
            </div>
            <div style={{ height: '6px', background: 'var(--bg-surface)', borderRadius: '999px', overflow: 'hidden', marginBottom: '10px' }}>
              <div style={{ width: `${job.progress}%`, height: '100%', background: job.status === 'failed' ? 'var(--poor)' : 'var(--accent)', transition: 'width 0.3s ease' }} />
            </div>
            <div style={{ fontSize: '13px', color: 'var(--text-2)', lineHeight: 1.6, marginBottom: '10px' }}>
              {job.error || job.message || 'Queued'}
            </div>
            <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', fontSize: '12px', color: 'var(--text-3)', marginBottom: '10px' }}>
              <span>Model: {job.model}</span>
              <span>Cost: {job.estimated_cost ? `$${job.estimated_cost.toFixed(4)}` : '—'}</span>
              <span>Tokens: {(job.input_tokens || 0) + (job.output_tokens || 0)}</span>
            </div>
            <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
              {job.artifacts?.report_url && <a href={job.artifacts.report_url} style={linkStyle}>Download Report</a>}
              {job.artifacts?.pdf_url && <a href={job.artifacts.pdf_url} style={linkStyle}>Download PDF</a>}
              {job.artifacts?.data_url && <a href={job.artifacts.data_url} style={linkStyle}>Download Data</a>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

const linkStyle = {
  color: 'var(--accent)',
  textDecoration: 'none',
  fontSize: '12px',
  fontFamily: 'var(--font-mono)',
};
